var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "page-editor-ui": "static-1.37662",
      "ably": "static-3.46",
      "apollo-dlb": "static-3.80",
      "client-types": "static-1.444",
      "codemirror-dlb": "static-1.58035",
      "collaboration-sidebar": "static-1.57056",
      "ContentComponents": "static-2.70518",
      "ContentData": "static-1.67637",
      "ContentEditorUI": "static-2.76476",
      "ContentUtils": "static-1.67562",
      "customer-agent-datasources-lib": "static-1.6299",
      "customer-agent-discovery-components-lib": "static-1.2384",
      "customer-agent-forms": "static-1.4120",
      "data-fetching-client": "static-1.9456",
      "editor-components": "static-1.12907",
      "emoji-mart": "static-3.4",
      "FileManagerLib": "static-1.38466",
      "foundations-assets": "static-1.4611",
      "foundations-components": "static-1.7483",
      "head-dlb": "static-1.4754",
      "hs-test-utils": "static-1.7783",
      "hub-http": "static-1.5966",
      "hub-http-shared-msw-handlers": "static-1.9429",
      "hubspot-dlb": "static-2.1796",
      "HubStyleTokens": "static-2.11201",
      "I18n": "static-7.1562",
      "InpageEditorUI": "static-1.84916",
      "jasmine-immutable": "static-1.2796",
      "jasmine-runner": "static-1.6250",
      "layout-dnd-utils": "static-1.10965",
      "personalization-lib": "static-1.6789",
      "quartz": "static-1.6694",
      "react-dlb": "static-1.71",
      "react-dnd": "static-4.51",
      "react-dnd-html5-backend": "static-4.5",
      "react-redux": "static-7.66",
      "react-router-dom": "static-5.26",
      "react-utils": "static-2.5153",
      "redux-thunk": "static-2.43",
      "settings-ui-lib": "static-1.12298",
      "sinon": "static-1.9",
      "tinymce": "static-6.5",
      "ui-addon-draggable": "static-1.4383",
      "ui-components-test-utils": "static-1.5339",
      "ui-images": "static-2.1085",
      "ui-memberships-settings-lib": "static-1.33373",
      "video-components-external": "static-1.10503",
      "webpack-env": "static-1.54",
      "ai-components-ui-library": "static-1.8294",
      "amplitude-session-replay-browser": "static-1.55",
      "apollo-stack-hubspot": "static-3.79",
      "asset-actions-lib": "static-1.45481",
      "atom": "static-1.4848",
      "blueimp-md5": "static-1.8",
      "campaigns-lib": "static-1.26371",
      "classnames": "static-2.10",
      "content-assistance-lib": "static-1.7416",
      "content-label-lib": "static-1.6580",
      "content-management-actions-lib": "static-1.27020",
      "content-management-data-lib": "static-1.5082",
      "content-management-restrictions-lib": "static-1.4887",
      "copilot-plugins": "static-1.10441",
      "copilot-toolkit": "static-1.10468",
      "cropperjs": "static-1.10",
      "cssUtils": "static-1.725",
      "cta-picker": "static-1.35795",
      "customer-data-objects": "static-1.7422",
      "customer-data-objects-ui-components": "static-1.12782",
      "customer-data-properties": "static-1.50743",
      "customer-data-property-utils": "static-1.7849",
      "customer-data-reference-ui-components": "static-1.12919",
      "customer-data-ui-utilities": "static-1.9601",
      "data-token-picker": "static-1.16005",
      "data-token-views": "static-1.15986",
      "error-messaging-js": "static-1.4962",
      "feedback-loader": "static-1.28813",
      "file-manager-components": "static-1.22826",
      "FileManagerCore": "static-1.38325",
      "FormsCommonComponents": "static-1.85244",
      "foundations-theming": "static-1.4187",
      "fuzzy": "static-1.8",
      "growth-onboarding-beacon": "static-1.4851",
      "growth-onboarding-confetti": "static-1.2848",
      "growth-onboarding-next-action-components": "static-1.1301",
      "growth-payments-core": "static-1.24672",
      "history": "static-4.47",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.5369",
      "hub-http-contrib": "static-1.2822",
      "hubspot-url-utils": "static-1.3917",
      "HubStyle": "static-2.11509",
      "icons": "static-2.618",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "InboxConnectUtils": "static-4.14171",
      "integrations-lib": "static-1.15354",
      "interframe": "static-3.4569",
      "laboratory-lib": "static-3.6940",
      "layout-data-lib": "static-1.9290",
      "media-bridge-lib": "static-1.18527",
      "nav-meta": "static-1.28842",
      "object-builder-ui-client": "static-1.47900",
      "onboarding-scopes": "static-1.6241",
      "onboarding-tours": "static-1.16225",
      "onboarding-tours-client": "static-1.4439",
      "outpost": "static-1.3982",
      "page-lib": "static-1.21730",
      "PatternValidationJS": "static-1.437",
      "payment-link-components": "static-1.22888",
      "payments-post-enroll-local-storage-lib": "static-1.4890",
      "pictos": "static-7.179",
      "PortalIdParser": "static-2.349",
      "products-ui-components": "static-1.39319",
      "property-translator": "static-1.5191",
      "quick-fetch": "static-1.3713",
      "raven": "static-3.5624",
      "react": "static-7.177",
      "react-beautiful-dnd": "static-1.13",
      "react-colorpicker": "static-2.9989",
      "react-dom": "static-7.85",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-rhumb": "static-1.16419",
      "react-select-plus": "static-1.65",
      "react-tinymce": "static-1.54563",
      "react-virtualized": "static-2.94",
      "redux": "static-4.16",
      "redux-request-state": "static-1.10425",
      "reference-resolvers": "static-1.7938",
      "reference-resolvers-lite": "static-1.7868",
      "reselect": "static-2.16",
      "rich-text-lib": "static-1.19433",
      "rpc-client-utils": "static-1.4410",
      "sanitize": "static-1.4252",
      "sanitize-text": "static-1.7918",
      "seamless-immutable": "static-7.6",
      "self-service-api": "static-1.10014",
      "SharedI18nStrings": "static-1.180",
      "SharedLegalStrings": "static-1.1532",
      "simple-menus-core": "static-1.14781",
      "simple-menus-lib": "static-1.16298",
      "smart-content-lib": "static-1.42457",
      "styled-components": "static-2.84",
      "StyleGuideUI": "static-3.483",
      "superstore": "static-1.4549",
      "theme-previewer-lib": "static-1.52649",
      "tinymce-config": "static-2.53689",
      "tinymce-copilot": "static-1.15757",
      "tinymce-data": "static-1.39774",
      "tinymce-plugins": "static-1.56803",
      "tinymce-themes": "static-1.55659",
      "transmute": "static-2.85",
      "ui-addon-emoji-picker": "static-1.9666",
      "ui-addon-form-validation": "static-1.10772",
      "ui-addon-i18n": "static-1.10910",
      "ui-addon-iframeable": "static-1.8819",
      "ui-addon-opt": "static-4.8163",
      "ui-addon-sales-email": "static-1.4991",
      "ui-addon-upgrades": "static-9.17618",
      "ui-business-units-lib": "static-1.8803",
      "ui-gdpr-components": "static-1.10125",
      "ui-product-approvals": "static-1.27369",
      "ui-shepherd-react": "static-3.9922",
      "ui-suspension-banners-lib": "static-1.6162",
      "UIComponents": "static-3.8148",
      "underscore": "static-1.8",
      "urlinator": "static-1.4312",
      "usage-tracker": "static-1.7110",
      "usage-tracker-core": "static-1.6960",
      "usage-tracker-session-replay": "static-1.4796",
      "user-context": "static-1.4872",
      "video-embed": "static-1.34995",
      "web-interactives-components": "static-1.13365",
      "web-interactives-data": "static-1.13366",
      "wootric-nps": "static-1.6760",
      "xray-recommendation-lib": "static-1.7556",
      "codemirror": "static-5.90",
      "react-codemirror": "static-1.10404",
      "enviro": "static-4.387",
      "hs-promise-rejection-tracking": "static-1.5291",
      "raven-hubspot": "static-1.5931",
      "hoist-non-react-statics": "static-3.9",
      "metrics-js": "static-1.9391",
      "bend-plugin-trellis-migration": "static-1.3208",
      "moment": "static-3.26",
      "chatspot-widget-iframe": "static-1.20217",
      "collaboration-sidebar-common": "static-1.1853",
      "framework-data-schema-resolvers": "static-1.6648",
      "frontend-preferences-client": "static-1.7702",
      "magpie-lib": "static-1.5372",
      "quartz-config": "static-1.472",
      "quartz-core": "static-1.5913",
      "advanced-menus-core": "static-1.14782",
      "advanced-menus-lib": "static-1.11762",
      "automation-ui-ubb": "static-1.4994",
      "avatar-components": "static-1.2263",
      "cms-field-types": "static-1.4583",
      "content-embed-lib": "static-1.7119",
      "ExportDialog": "static-6.10166",
      "forms-utils-lib": "static-1.12127",
      "foundations-components-legacy": "static-1.508",
      "integrations-error-boundary-lib": "static-1.12769",
      "messaging-usage-based-billing-components-lib": "static-1.455",
      "payments-embed-points-lib": "static-1.12537",
      "products-iframe-lib": "static-1.7259",
      "react-dnd-compat": "static-1.4400",
      "ui-addon-draggable-compat": "static-2.4031",
      "usage-based-billing-components-lib": "static-1.7944",
      "usage-tracker-container": "static-1.7100",
      "video-data-lib": "static-1.34161",
      "videoconference-integration-components": "static-1.6500",
      "graphql": "static-1.77",
      "backbone": "static-1.6",
      "editor-iframe-lib": "static-1.8089",
      "FireAlarmUi": "static-1.4307",
      "hubspot-apollo-client": "static-1.4657",
      "layout-dnd-components": "static-1.11990",
      "marketing-email-service-types": "static-1.1770",
      "react-transition-group": "static-1.7",
      "smart-content-core": "static-1.41804",
      "social-composer-lib": "static-1.58052",
      "structured-content-lib": "static-1.24567",
      "timezone-utils": "static-2.5022",
      "ui-addon-video-player": "static-1.8474",
      "ui-asset-management-lib": "static-1.10678",
      "ui-brand-identity-lib": "static-1.13758",
      "ui-tool-access": "static-1.9921",
      "content-icons-ui": "static-1.2146",
      "conversations-skeleton-state": "static-1.7027",
      "final-form": "static-1.65",
      "hubspot-prosemirror": "static-1.17554",
      "prosemirror": "static-1.13",
      "foundations-theming-specialty": "static-1.1903",
      "fast-json-stable-stringify": "static-1.4",
      "react-aria": "static-1.61",
      "audio-components": "static-1.5580",
      "FileManagerImages": "static-1.35977",
      "quartz-i18n": "static-1.369",
      "video-components": "static-1.12506",
      "bend-plugin-foundations-components": "static-1.3752",
      "floating-ui": "static-1.51",
      "framer-motion": "static-1.67",
      "hs-story-utils": "static-1.9206",
      "tanstack-table": "static-1.50",
      "trellis-assets": "static-1.1127",
      "ui-fonts": "static-1.463",
      "HeadJS": "static-2.704",
      "hs-test-utils-bend-plugin": "static-1.2894",
      "msw": "static-1.39",
      "testing-library": "static-1.147",
      "ts-schema": "static-1.3884",
      "i18n-data": "static-1.216",
      "moment-timezone": "static-5.78",
      "jquery": "static-3.6",
      "NamespacedHubStyle": "static-2.8876",
      "react-dnd-ipeui-backend": "static-1.1762",
      "ui-coaching-tips": "static-1.27890",
      "jasmine": "static-4.4107",
      "marketplace-embed": "static-1.21430",
      "ui-addon-react-router-dom": "static-1.9326",
      "flux-actions": "static-1.304",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10150",
      "rxjs": "static-5.10",
      "react-flip-move": "static-1.65",
      "foundations-components-test-utils": "static-1.4966",
      "apollo-link-hub-http": "static-2.4426",
      "content-media-composition-data-lib": "static-1.11367",
      "content-media-compositions": "static-2.15374",
      "idb-keyval": "static-1.39",
      "immerable": "static-1.3932",
      "magpie-types": "static-1.4832",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.20225",
      "chirp-fetch": "static-1.1662",
      "foundations-theming-base": "static-1.3172",
      "sassPrefix": "static-1.151",
      "marketing-platform-lib": "static-1.6613",
      "attribution-lib": "static-1.41609",
      "crm-message-bus": "static-1.42295",
      "crm-pipelines-api-client-types": "static-1.3944",
      "nudge-client-utils": "static-1.2145",
      "nudge-custom-ui-functions": "static-1.662",
      "reporting-enablement": "static-1.22007",
      "reporting-ui-components": "static-2.63701",
      "hubspotter-http": "static-1.4457",
      "ai-rendering-library": "static-1.9236",
      "simple-logging-lib": "static-1.2828",
      "inbound-db-properties-service-client": "static-1.3655",
      "calling-global-api": "static-1.63586",
      "calling-internal-common": "static-1.31071",
      "calling-lifecycle-internal": "static-1.64968",
      "calling-lifecycle-messages": "static-1.57262",
      "commerce-products-lib": "static-1.8800",
      "conditional-properties-service-client": "static-1.3604",
      "crm-links": "static-1.6034",
      "external-options-client-types": "static-1.3964",
      "google-libphonenumber": "static-1.33",
      "hs-entities": "static-1.452",
      "inbound-db-meta-service-client": "static-1.3397",
      "inbounddb-objects-service-types": "static-1.4030",
      "meetings-icalendar-utils-lib": "static-1.411",
      "multi-currency-client-types": "static-1.3498",
      "pipeline-validation-client-types": "static-1.3766",
      "property-value-citations": "static-1.1357",
      "pulse": "static-1.284",
      "smart-property-lib": "static-1.5802",
      "tiered-pricing": "static-1.794",
      "react-immutable-render-mixin": "static-1.9",
      "redux-toolkit": "static-1.7",
      "salesImages": "static-1.520",
      "ui-universal-auth": "static-1.8659",
      "forms-ai-lib": "static-1.3979",
      "bend-plugin-foundations-theming": "static-1.2670",
      "stylex": "static-1.27",
      "embedded-academy-lib": "static-1.13429",
      "growth-onboarding-feedback-components": "static-1.6363",
      "integrations-tracking-lib": "static-1.5363",
      "native-integrations-shared-strings": "static-1.7566",
      "getting-started-shared-tasks": "static-1.17827",
      "growth-data-modal": "static-1.5129",
      "growth-onboarding-next-action-utils": "static-1.1273",
      "navigation-components": "static-1.17205",
      "onboarding-tours-utils": "static-1.291",
      "ui-shepherd-tracker": "static-1.7303",
      "commerce-tours-lib": "static-1.5683",
      "growth-onboarding-reliability": "static-1.4866",
      "sales-checkout-service-client": "static-1.3456",
      "commerce-permissions": "static-1.530",
      "commerce-subscription-lib": "static-1.36383",
      "commerce-tax-lib": "static-1.287",
      "crm_data": "static-4.91154",
      "customer-data-filters-ui": "static-1.38822",
      "customer-data-tracking": "static-1.6659",
      "dispatcher": "static-1.131",
      "framework-data-table": "static-2.11361",
      "property-description-translator": "static-1.3637",
      "quartz-head": "static-1.359",
      "quartz-test": "static-1.369",
      "csstype": "static-1.50",
      "batch-promise": "static-1.1328",
      "merchandise-lib": "static-1.258",
      "commerce-tools-ui-lib": "static-1.9742",
      "redux-mock-store": "static-1.8",
      "redux-undo": "static-1.10",
      "navigation-messaging": "static-1.6532",
      "purchase-motions-components": "static-1.5451",
      "upgrade-management-service-types": "static-1.4285",
      "getting-started-shared-tasks-store": "static-1.16945",
      "seo-tools-lib": "static-1.6203",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "bender-build-tools": "static-1.2921",
      "zustand": "static-1.51",
      "framework-builder-read-service-client": "static-1.3817",
      "framework-data-schema-quick-fetch": "static-1.6553",
      "persist-promise": "static-1.3485",
      "hub-http-janus": "static-1.787",
      "reactive-lib": "static-1.504",
      "general-store": "static-6.20",
      "mobile-manifest-mixins": "static-1.477",
      "module-federation": "static-1.18",
      "quartz-auth": "static-1.369",
      "quartz-routing": "static-1.124",
      "automation-platform-service-types": "static-1.2481",
      "automation-ui-core": "static-2.21014",
      "automation-ui-types": "static-1.19078",
      "automation-ui-usage-tracking": "static-1.20477",
      "data-studio-ubb": "static-1.2024",
      "commerce-analytics-service-client": "static-1.3444",
      "payments-enrollment-embed-lib": "static-1.21932",
      "highcharts": "static-8.99",
      "platform-infra-nav-components": "static-1.7473",
      "reporting-visualizations": "static-1.58506",
      "subscription-experience-data-types": "static-1.14558",
      "hubspot-apollo-cache": "static-1.116",
      "knowledge-content-types": "static-1.8347",
      "social-insights-client-types": "static-1.21265",
      "connections-embed-lib": "static-1.592",
      "marketplace-ui-common": "static-1.18879",
      "marketplace-ui-details": "static-1.8775",
      "marketplace-ui-tracking": "static-1.13050",
      "property-management-iframe": "static-1.12241",
      "trellis-ecosystem": "static-1.6685",
      "hls.js": "static-1.34",
      "js-cookie": "static-1.18",
      "markdown-it": "static-1.6",
      "FormUrlGenerator": "static-2.4508",
      "report-customization-components": "static-1.12447",
      "reporting-action-components": "static-1.40609",
      "reporting-data": "static-1.66430",
      "reporting-snowflake": "static-1.55048",
      "nudge-custom-function-registry": "static-1.1901",
      "nudge-renderer-utils": "static-1.2220",
      "whisper-core-api": "static-1.5939",
      "data-quality-ui-library": "static-1.12271",
      "html-to-image": "static-1.49",
      "reporting-insights-lib": "static-1.1106",
      "reporting-plugins": "static-1.9953",
      "reporting-reports": "static-1.66108",
      "ui-addon-teams": "static-1.21209",
      "highlight.js": "static-1.74",
      "calling-error-reporting": "static-1.31077",
      "shared-worker-versioning": "static-1.10814",
      "calling-usage-tracker": "static-1.6316",
      "voice-sms-access-library": "static-1.188",
      "products-ui-components-shared-msw-handlers": "static-1.9811",
      "location-customization-utils-lib": "static-1.8499",
      "directed-graph": "static-1.715",
      "event-emitter": "static-1.725",
      "breeze-intelligence-kit": "static-1.5288",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9512",
      "fsm": "static-1.3509",
      "policy-lib": "static-1.6559",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9575",
      "unified-auth-core-lib": "static-1.454",
      "academy-common-lib": "static-1.12889",
      "universal-page-editor-lib": "static-1.2775",
      "commerce-billing-lib": "static-1.18446",
      "commerce-shared-components-lib": "static-1.17858",
      "crm_universal": "static-1.21623",
      "customer-data-email": "static-1.17631",
      "customer-data-filters-ui-msw-helpers": "static-1.21256",
      "multi-account-reference-resolvers": "static-1.748",
      "reporting-datasets-permissions-lib": "static-1.12980",
      "customer-data-associations": "static-1.7113",
      "deal-intel-decorators": "static-1.1189",
      "tanstack-virtual": "static-1.25",
      "customer-data-rte": "static-1.32397",
      "cv-backend-services": "static-1.1491",
      "growth-onboarding-empty-states": "static-1.5330",
      "qrcode-generator": "static-1.64",
      "quotes-client-types": "static-1.37185",
      "trials-service-types": "static-1.3702",
      "growth-monetization-service-types": "static-1.4301",
      "nav-client-types": "static-1.2134",
      "purchase-motions-api": "static-1.5454",
      "signup-constants": "static-1.18342",
      "signup-ui-url-generator": "static-2.7843",
      "hubspotter-http-shared-msw-handlers": "static-1.9427",
      "immutable-less": "static-1.4431",
      "automation-ui-routing": "static-1.20435",
      "sql-reporting-client-types": "static-1.5454",
      "marketplace-ui-apps-core": "static-1.17412",
      "stripe-embedded-components": "static-1.7095",
      "edison-service-client-types": "static-1.169",
      "unified-auth": "static-1.173",
      "ai-settings-ui-library": "static-1.7382",
      "marketplace-ui-client-types": "static-1.16286",
      "react-window": "static-1.13",
      "ai-studio-lib": "static-1.10943",
      "developer-experience-shared-components": "static-1.10246",
      "marketplace-ui-reviews": "static-1.18835",
      "ui-addon-integrations-directory-panel": "static-2.7762",
      "property-management-common": "static-1.4528",
      "storybook-react": "static-1.28",
      "trellis-story-utils": "static-1.4301",
      "dashboard-lib": "static-1.80548",
      "hubspot-prosemirror-plugins": "static-1.17546",
      "share-with-third-party-component-lib": "static-1.8469",
      "reporting-client-types": "static-1.2382",
      "campaign-roi-lib": "static-1.8214",
      "calling-orchestration-schema": "static-1.34965",
      "sales-views-client-types": "static-1.4070",
      "crm-record-cards-service-types": "static-1.3432",
      "academy-service-client": "static-1.3460",
      "utility-belt": "static-1.2320",
      "sequences-lib": "static-1.7653",
      "deal-intel-utils": "static-1.1193",
      "draft-content-plugins": "static-1.27665",
      "draft-convert": "static-2.67",
      "draft-extend": "static-3.70",
      "draft-js": "static-5.72",
      "draft-plugins": "static-2.21271",
      "eligibility-engine-service-types": "static-1.2983",
      "ui-extensibility-client-types": "static-1.3725",
      "stripe-connect-js": "static-1.64",
      "simple-data-table": "static-1.2132",
      "apps-service-types": "static-1.3657",
      "oauth-service-types": "static-1.4019",
      "crm-component-utils": "static-1.38443",
      "crm-properties-common-lib": "static-1.5649",
      "redux-actions": "static-3.7",
      "EmailSignatureEditor": "static-1.23862",
      "viral-links-lib": "static-1.6808",
      "sequences-client-types-lib": "static-1.7510",
      "card-properties-lib": "static-1.43465",
      "crm-actions": "static-1.6074",
      "crm-cards-data": "static-1.1165",
      "crm-cards-sdk": "static-1.42856",
      "customer-data-properties-shared-msw-handlers": "static-1.8756",
      "sales-email-signature-service-client": "static-1.3623",
      "customer-data-sidebar": "static-2.45362",
      "enrichment-properties-lib": "static-1.14920",
      "crm-fe-perf": "static-1.22684",
      "card-payment-highlight-lib": "static-1.36452",
      "card-subscription-highlight-lib": "static-1.38806",
      "commerce-contract-lib": "static-1.11086",
      "customer-data-content": "static-1.26835",
      "invoices-highlight-card-lib": "static-1.53949",
      "orders-highlight-card-lib": "static-1.20820",
      "products-highlight-card-lib": "static-1.17084",
      "project-storage": "static-1.4510",
      "quotes-highlight-card-lib": "static-1.71097",
      "crm-source-interpretation-lib": "static-1.5106",
      "quotes-ui-lib": "static-1.79816",
      "SalesContentIndexUI": "static-3.8867",
      "accounting-integrations-ui-components": "static-1.6688",
      "invoices-ui-lib": "static-1.53965",
      "commerce-products-api": "static-1.1924",
      "SafeStorage": "static-1.4182",
      "invoices-iframe-lib": "static-1.56023",
      "quotes-modal-lib": "static-1.101773",
      "sales-templates-service-types-lib": "static-1.3974",
      "totals-ui-components": "static-1.22946",
      "commerce-totals-service-types": "static-1.3618"
    },
    "depPathPrefixes": {
      "page-editor-ui": "/page-editor-ui/static-1.37662",
      "ably": "/ably/static-3.46",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "client-types": "/client-types/static-1.444",
      "codemirror-dlb": "/codemirror-dlb/static-1.58035",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57056",
      "ContentComponents": "/ContentComponents/static-2.70518",
      "ContentData": "/ContentData/static-1.67637",
      "ContentEditorUI": "/ContentEditorUI/static-2.76476",
      "ContentUtils": "/ContentUtils/static-1.67562",
      "customer-agent-datasources-lib": "/customer-agent-datasources-lib/static-1.6299",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2384",
      "customer-agent-forms": "/customer-agent-forms/static-1.4120",
      "data-fetching-client": "/data-fetching-client/static-1.9456",
      "editor-components": "/editor-components/static-1.12907",
      "emoji-mart": "/emoji-mart/static-3.4",
      "FileManagerLib": "/FileManagerLib/static-1.38466",
      "foundations-assets": "/foundations-assets/static-1.4611",
      "foundations-components": "/foundations-components/static-1.7483",
      "head-dlb": "/head-dlb/static-1.4754",
      "hs-test-utils": "/hs-test-utils/static-1.7783",
      "hub-http": "/hub-http/static-1.5966",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9429",
      "hubspot-dlb": "/hubspot-dlb/static-2.1796",
      "HubStyleTokens": "/HubStyleTokens/static-2.11201",
      "I18n": "/I18n/static-7.1562",
      "InpageEditorUI": "/InpageEditorUI/static-1.84916",
      "jasmine-immutable": "/jasmine-immutable/static-1.2796",
      "jasmine-runner": "/jasmine-runner/static-1.6250",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10965",
      "personalization-lib": "/personalization-lib/static-1.6789",
      "quartz": "/quartz/static-1.6694",
      "react-dlb": "/react-dlb/static-1.71",
      "react-dnd": "/react-dnd/static-4.51",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
      "react-redux": "/react-redux/static-7.66",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-utils": "/react-utils/static-2.5153",
      "redux-thunk": "/redux-thunk/static-2.43",
      "settings-ui-lib": "/settings-ui-lib/static-1.12298",
      "sinon": "/sinon/static-1.9",
      "tinymce": "/tinymce/static-6.5",
      "ui-addon-draggable": "/ui-addon-draggable/static-1.4383",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5339",
      "ui-images": "/ui-images/static-2.1085",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33373",
      "video-components-external": "/video-components-external/static-1.10503",
      "webpack-env": "/webpack-env/static-1.54",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8294",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
      "asset-actions-lib": "/asset-actions-lib/static-1.45481",
      "atom": "/atom/static-1.4848",
      "blueimp-md5": "/blueimp-md5/static-1.8",
      "campaigns-lib": "/campaigns-lib/static-1.26371",
      "classnames": "/classnames/static-2.10",
      "content-assistance-lib": "/content-assistance-lib/static-1.7416",
      "content-label-lib": "/content-label-lib/static-1.6580",
      "content-management-actions-lib": "/content-management-actions-lib/static-1.27020",
      "content-management-data-lib": "/content-management-data-lib/static-1.5082",
      "content-management-restrictions-lib": "/content-management-restrictions-lib/static-1.4887",
      "copilot-plugins": "/copilot-plugins/static-1.10441",
      "copilot-toolkit": "/copilot-toolkit/static-1.10468",
      "cropperjs": "/cropperjs/static-1.10",
      "cssUtils": "/cssUtils/static-1.725",
      "cta-picker": "/cta-picker/static-1.35795",
      "customer-data-objects": "/customer-data-objects/static-1.7422",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12782",
      "customer-data-properties": "/customer-data-properties/static-1.50743",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7849",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12919",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9601",
      "data-token-picker": "/data-token-picker/static-1.16005",
      "data-token-views": "/data-token-views/static-1.15986",
      "error-messaging-js": "/error-messaging-js/static-1.4962",
      "feedback-loader": "/feedback-loader/static-1.28813",
      "file-manager-components": "/file-manager-components/static-1.22826",
      "FileManagerCore": "/FileManagerCore/static-1.38325",
      "FormsCommonComponents": "/FormsCommonComponents/static-1.85244",
      "foundations-theming": "/foundations-theming/static-1.4187",
      "fuzzy": "/fuzzy/static-1.8",
      "growth-onboarding-beacon": "/growth-onboarding-beacon/static-1.4851",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2848",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1301",
      "growth-payments-core": "/growth-payments-core/static-1.24672",
      "history": "/history/static-4.47",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.5369",
      "hub-http-contrib": "/hub-http-contrib/static-1.2822",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
      "HubStyle": "/HubStyle/static-2.11509",
      "icons": "/icons/static-2.618",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14171",
      "integrations-lib": "/integrations-lib/static-1.15354",
      "interframe": "/interframe/static-3.4569",
      "laboratory-lib": "/laboratory-lib/static-3.6940",
      "layout-data-lib": "/layout-data-lib/static-1.9290",
      "media-bridge-lib": "/media-bridge-lib/static-1.18527",
      "nav-meta": "/nav-meta/static-1.28842",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47900",
      "onboarding-scopes": "/onboarding-scopes/static-1.6241",
      "onboarding-tours": "/onboarding-tours/static-1.16225",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4439",
      "outpost": "/outpost/static-1.3982",
      "page-lib": "/page-lib/static-1.21730",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "payment-link-components": "/payment-link-components/static-1.22888",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4890",
      "pictos": "/pictos/static-7.179",
      "PortalIdParser": "/PortalIdParser/static-2.349",
      "products-ui-components": "/products-ui-components/static-1.39319",
      "property-translator": "/property-translator/static-1.5191",
      "quick-fetch": "/quick-fetch/static-1.3713",
      "raven": "/raven/static-3.5624",
      "react": "/react/static-7.177",
      "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
      "react-colorpicker": "/react-colorpicker/static-2.9989",
      "react-dom": "/react-dom/static-7.85",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-rhumb": "/react-rhumb/static-1.16419",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-tinymce": "/react-tinymce/static-1.54563",
      "react-virtualized": "/react-virtualized/static-2.94",
      "redux": "/redux/static-4.16",
      "redux-request-state": "/redux-request-state/static-1.10425",
      "reference-resolvers": "/reference-resolvers/static-1.7938",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7868",
      "reselect": "/reselect/static-2.16",
      "rich-text-lib": "/rich-text-lib/static-1.19433",
      "rpc-client-utils": "/rpc-client-utils/static-1.4410",
      "sanitize": "/sanitize/static-1.4252",
      "sanitize-text": "/sanitize-text/static-1.7918",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "self-service-api": "/self-service-api/static-1.10014",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
      "SharedLegalStrings": "/SharedLegalStrings/static-1.1532",
      "simple-menus-core": "/simple-menus-core/static-1.14781",
      "simple-menus-lib": "/simple-menus-lib/static-1.16298",
      "smart-content-lib": "/smart-content-lib/static-1.42457",
      "styled-components": "/styled-components/static-2.84",
      "StyleGuideUI": "/StyleGuideUI/static-3.483",
      "superstore": "/superstore/static-1.4549",
      "theme-previewer-lib": "/theme-previewer-lib/static-1.52649",
      "tinymce-config": "/tinymce-config/static-2.53689",
      "tinymce-copilot": "/tinymce-copilot/static-1.15757",
      "tinymce-data": "/tinymce-data/static-1.39774",
      "tinymce-plugins": "/tinymce-plugins/static-1.56803",
      "tinymce-themes": "/tinymce-themes/static-1.55659",
      "transmute": "/transmute/static-2.85",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9666",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10772",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10910",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8819",
      "ui-addon-opt": "/ui-addon-opt/static-4.8163",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4991",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17618",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8803",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10125",
      "ui-product-approvals": "/ui-product-approvals/static-1.27369",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9922",
      "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.6162",
      "UIComponents": "/UIComponents/static-3.8148",
      "underscore": "/underscore/static-1.8",
      "urlinator": "/urlinator/static-1.4312",
      "usage-tracker": "/usage-tracker/static-1.7110",
      "usage-tracker-core": "/usage-tracker-core/static-1.6960",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4796",
      "user-context": "/user-context/static-1.4872",
      "video-embed": "/video-embed/static-1.34995",
      "web-interactives-components": "/web-interactives-components/static-1.13365",
      "web-interactives-data": "/web-interactives-data/static-1.13366",
      "wootric-nps": "/wootric-nps/static-1.6760",
      "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7556",
      "codemirror": "/codemirror/static-5.90",
      "react-codemirror": "/react-codemirror/static-1.10404",
      "enviro": "/enviro/static-4.387",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
      "raven-hubspot": "/raven-hubspot/static-1.5931",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "metrics-js": "/metrics-js/static-1.9391",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3208",
      "moment": "/moment/static-3.26",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20217",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1853",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6648",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7702",
      "magpie-lib": "/magpie-lib/static-1.5372",
      "quartz-config": "/quartz-config/static-1.472",
      "quartz-core": "/quartz-core/static-1.5913",
      "advanced-menus-core": "/advanced-menus-core/static-1.14782",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11762",
      "automation-ui-ubb": "/automation-ui-ubb/static-1.4994",
      "avatar-components": "/avatar-components/static-1.2263",
      "cms-field-types": "/cms-field-types/static-1.4583",
      "content-embed-lib": "/content-embed-lib/static-1.7119",
      "ExportDialog": "/ExportDialog/static-6.10166",
      "forms-utils-lib": "/forms-utils-lib/static-1.12127",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.508",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12769",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.455",
      "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12537",
      "products-iframe-lib": "/products-iframe-lib/static-1.7259",
      "react-dnd-compat": "/react-dnd-compat/static-1.4400",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4031",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7944",
      "usage-tracker-container": "/usage-tracker-container/static-1.7100",
      "video-data-lib": "/video-data-lib/static-1.34161",
      "videoconference-integration-components": "/videoconference-integration-components/static-1.6500",
      "graphql": "/graphql/static-1.77",
      "backbone": "/backbone/static-1.6",
      "editor-iframe-lib": "/editor-iframe-lib/static-1.8089",
      "FireAlarmUi": "/FireAlarmUi/static-1.4307",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4657",
      "layout-dnd-components": "/layout-dnd-components/static-1.11990",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1770",
      "react-transition-group": "/react-transition-group/static-1.7",
      "smart-content-core": "/smart-content-core/static-1.41804",
      "social-composer-lib": "/social-composer-lib/static-1.58052",
      "structured-content-lib": "/structured-content-lib/static-1.24567",
      "timezone-utils": "/timezone-utils/static-2.5022",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8474",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10678",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13758",
      "ui-tool-access": "/ui-tool-access/static-1.9921",
      "content-icons-ui": "/content-icons-ui/static-1.2146",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7027",
      "final-form": "/final-form/static-1.65",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17554",
      "prosemirror": "/prosemirror/static-1.13",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1903",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "react-aria": "/react-aria/static-1.61",
      "audio-components": "/audio-components/static-1.5580",
      "FileManagerImages": "/FileManagerImages/static-1.35977",
      "quartz-i18n": "/quartz-i18n/static-1.369",
      "video-components": "/video-components/static-1.12506",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3752",
      "floating-ui": "/floating-ui/static-1.51",
      "framer-motion": "/framer-motion/static-1.67",
      "hs-story-utils": "/hs-story-utils/static-1.9206",
      "tanstack-table": "/tanstack-table/static-1.50",
      "trellis-assets": "/trellis-assets/static-1.1127",
      "ui-fonts": "/ui-fonts/static-1.463",
      "HeadJS": "/HeadJS/static-2.704",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2894",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.147",
      "ts-schema": "/ts-schema/static-1.3884",
      "i18n-data": "/i18n-data/static-1.216",
      "moment-timezone": "/moment-timezone/static-5.78",
      "jquery": "/jquery/static-3.6",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8876",
      "react-dnd-ipeui-backend": "/react-dnd-ipeui-backend/static-1.1762",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27890",
      "jasmine": "/jasmine/static-4.4107",
      "marketplace-embed": "/marketplace-embed/static-1.21430",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9326",
      "flux-actions": "/flux-actions/static-1.304",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10150",
      "rxjs": "/rxjs/static-5.10",
      "react-flip-move": "/react-flip-move/static-1.65",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4966",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4426",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11367",
      "content-media-compositions": "/content-media-compositions/static-2.15374",
      "idb-keyval": "/idb-keyval/static-1.39",
      "immerable": "/immerable/static-1.3932",
      "magpie-types": "/magpie-types/static-1.4832",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.20225",
      "chirp-fetch": "/chirp-fetch/static-1.1662",
      "foundations-theming-base": "/foundations-theming-base/static-1.3172",
      "sassPrefix": "/sassPrefix/static-1.151",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6613",
      "attribution-lib": "/attribution-lib/static-1.41609",
      "crm-message-bus": "/crm-message-bus/static-1.42295",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3944",
      "nudge-client-utils": "/nudge-client-utils/static-1.2145",
      "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.662",
      "reporting-enablement": "/reporting-enablement/static-1.22007",
      "reporting-ui-components": "/reporting-ui-components/static-2.63701",
      "hubspotter-http": "/hubspotter-http/static-1.4457",
      "ai-rendering-library": "/ai-rendering-library/static-1.9236",
      "simple-logging-lib": "/simple-logging-lib/static-1.2828",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3655",
      "calling-global-api": "/calling-global-api/static-1.63586",
      "calling-internal-common": "/calling-internal-common/static-1.31071",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64968",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57262",
      "commerce-products-lib": "/commerce-products-lib/static-1.8800",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3604",
      "crm-links": "/crm-links/static-1.6034",
      "external-options-client-types": "/external-options-client-types/static-1.3964",
      "google-libphonenumber": "/google-libphonenumber/static-1.33",
      "hs-entities": "/hs-entities/static-1.452",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4030",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.411",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3498",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3766",
      "property-value-citations": "/property-value-citations/static-1.1357",
      "pulse": "/pulse/static-1.284",
      "smart-property-lib": "/smart-property-lib/static-1.5802",
      "tiered-pricing": "/tiered-pricing/static-1.794",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "salesImages": "/salesImages/static-1.520",
      "ui-universal-auth": "/ui-universal-auth/static-1.8659",
      "forms-ai-lib": "/forms-ai-lib/static-1.3979",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2670",
      "stylex": "/stylex/static-1.27",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13429",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6363",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5363",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7566",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17827",
      "growth-data-modal": "/growth-data-modal/static-1.5129",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1273",
      "navigation-components": "/navigation-components/static-1.17205",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.291",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7303",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5683",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4866",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3456",
      "commerce-permissions": "/commerce-permissions/static-1.530",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36383",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.287",
      "crm_data": "/crm_data/static-4.91154",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38822",
      "customer-data-tracking": "/customer-data-tracking/static-1.6659",
      "dispatcher": "/dispatcher/static-1.131",
      "framework-data-table": "/framework-data-table/static-2.11361",
      "property-description-translator": "/property-description-translator/static-1.3637",
      "quartz-head": "/quartz-head/static-1.359",
      "quartz-test": "/quartz-test/static-1.369",
      "csstype": "/csstype/static-1.50",
      "batch-promise": "/batch-promise/static-1.1328",
      "merchandise-lib": "/merchandise-lib/static-1.258",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9742",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-undo": "/redux-undo/static-1.10",
      "navigation-messaging": "/navigation-messaging/static-1.6532",
      "purchase-motions-components": "/purchase-motions-components/static-1.5451",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4285",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16945",
      "seo-tools-lib": "/seo-tools-lib/static-1.6203",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "bender-build-tools": "/bender-build-tools/static-1.2921",
      "zustand": "/zustand/static-1.51",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6553",
      "persist-promise": "/persist-promise/static-1.3485",
      "hub-http-janus": "/hub-http-janus/static-1.787",
      "reactive-lib": "/reactive-lib/static-1.504",
      "general-store": "/general-store/static-6.20",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.477",
      "module-federation": "/module-federation/static-1.18",
      "quartz-auth": "/quartz-auth/static-1.369",
      "quartz-routing": "/quartz-routing/static-1.124",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2481",
      "automation-ui-core": "/automation-ui-core/static-2.21014",
      "automation-ui-types": "/automation-ui-types/static-1.19078",
      "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20477",
      "data-studio-ubb": "/data-studio-ubb/static-1.2024",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3444",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21932",
      "highcharts": "/highcharts/static-8.99",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7473",
      "reporting-visualizations": "/reporting-visualizations/static-1.58506",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14558",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.116",
      "knowledge-content-types": "/knowledge-content-types/static-1.8347",
      "social-insights-client-types": "/social-insights-client-types/static-1.21265",
      "connections-embed-lib": "/connections-embed-lib/static-1.592",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18879",
      "marketplace-ui-details": "/marketplace-ui-details/static-1.8775",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13050",
      "property-management-iframe": "/property-management-iframe/static-1.12241",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.6685",
      "hls.js": "/hls.js/static-1.34",
      "js-cookie": "/js-cookie/static-1.18",
      "markdown-it": "/markdown-it/static-1.6",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4508",
      "report-customization-components": "/report-customization-components/static-1.12447",
      "reporting-action-components": "/reporting-action-components/static-1.40609",
      "reporting-data": "/reporting-data/static-1.66430",
      "reporting-snowflake": "/reporting-snowflake/static-1.55048",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.1901",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2220",
      "whisper-core-api": "/whisper-core-api/static-1.5939",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.12271",
      "html-to-image": "/html-to-image/static-1.49",
      "reporting-insights-lib": "/reporting-insights-lib/static-1.1106",
      "reporting-plugins": "/reporting-plugins/static-1.9953",
      "reporting-reports": "/reporting-reports/static-1.66108",
      "ui-addon-teams": "/ui-addon-teams/static-1.21209",
      "highlight.js": "/highlight.js/static-1.74",
      "calling-error-reporting": "/calling-error-reporting/static-1.31077",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10814",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6316",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.188",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9811",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8499",
      "directed-graph": "/directed-graph/static-1.715",
      "event-emitter": "/event-emitter/static-1.725",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5288",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9512",
      "fsm": "/fsm/static-1.3509",
      "policy-lib": "/policy-lib/static-1.6559",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9575",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.454",
      "academy-common-lib": "/academy-common-lib/static-1.12889",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2775",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18446",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17858",
      "crm_universal": "/crm_universal/static-1.21623",
      "customer-data-email": "/customer-data-email/static-1.17631",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21256",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.748",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12980",
      "customer-data-associations": "/customer-data-associations/static-1.7113",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1189",
      "tanstack-virtual": "/tanstack-virtual/static-1.25",
      "customer-data-rte": "/customer-data-rte/static-1.32397",
      "cv-backend-services": "/cv-backend-services/static-1.1491",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5330",
      "qrcode-generator": "/qrcode-generator/static-1.64",
      "quotes-client-types": "/quotes-client-types/static-1.37185",
      "trials-service-types": "/trials-service-types/static-1.3702",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4301",
      "nav-client-types": "/nav-client-types/static-1.2134",
      "purchase-motions-api": "/purchase-motions-api/static-1.5454",
      "signup-constants": "/signup-constants/static-1.18342",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7843",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9427",
      "immutable-less": "/immutable-less/static-1.4431",
      "automation-ui-routing": "/automation-ui-routing/static-1.20435",
      "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5454",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17412",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7095",
      "edison-service-client-types": "/edison-service-client-types/static-1.169",
      "unified-auth": "/unified-auth/static-1.173",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7382",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16286",
      "react-window": "/react-window/static-1.13",
      "ai-studio-lib": "/ai-studio-lib/static-1.10943",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10246",
      "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18835",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7762",
      "property-management-common": "/property-management-common/static-1.4528",
      "storybook-react": "/storybook-react/static-1.28",
      "trellis-story-utils": "/trellis-story-utils/static-1.4301",
      "dashboard-lib": "/dashboard-lib/static-1.80548",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17546",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8469",
      "reporting-client-types": "/reporting-client-types/static-1.2382",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8214",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34965",
      "sales-views-client-types": "/sales-views-client-types/static-1.4070",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3432",
      "academy-service-client": "/academy-service-client/static-1.3460",
      "utility-belt": "/utility-belt/static-1.2320",
      "sequences-lib": "/sequences-lib/static-1.7653",
      "deal-intel-utils": "/deal-intel-utils/static-1.1193",
      "draft-content-plugins": "/draft-content-plugins/static-1.27665",
      "draft-convert": "/draft-convert/static-2.67",
      "draft-extend": "/draft-extend/static-3.70",
      "draft-js": "/draft-js/static-5.72",
      "draft-plugins": "/draft-plugins/static-2.21271",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2983",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3725",
      "stripe-connect-js": "/stripe-connect-js/static-1.64",
      "simple-data-table": "/simple-data-table/static-1.2132",
      "apps-service-types": "/apps-service-types/static-1.3657",
      "oauth-service-types": "/oauth-service-types/static-1.4019",
      "crm-component-utils": "/crm-component-utils/static-1.38443",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5649",
      "redux-actions": "/redux-actions/static-3.7",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23862",
      "viral-links-lib": "/viral-links-lib/static-1.6808",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7510",
      "card-properties-lib": "/card-properties-lib/static-1.43465",
      "crm-actions": "/crm-actions/static-1.6074",
      "crm-cards-data": "/crm-cards-data/static-1.1165",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42856",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8756",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3623",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45362",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14920",
      "crm-fe-perf": "/crm-fe-perf/static-1.22684",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36452",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38806",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11086",
      "customer-data-content": "/customer-data-content/static-1.26835",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53949",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20820",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17084",
      "project-storage": "/project-storage/static-1.4510",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71097",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5106",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79816",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8867",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6688",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53965",
      "commerce-products-api": "/commerce-products-api/static-1.1924",
      "SafeStorage": "/SafeStorage/static-1.4182",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56023",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101773",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3974",
      "totals-ui-components": "/totals-ui-components/static-1.22946",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3618"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.37662",
    "project": "page-editor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};